
void main() {
  gl_FragColor = vec4(0.13, 0.43, 1.0, 0.4);
  #include <tonemapping_fragment>
  #include <colorspace_fragment>
}